import { type ComponentsOverrides, type Theme } from '@mui/material/styles'

export const overridesFormHelperText = (theme: Theme): ComponentsOverrides['MuiFormHelperText'] => ({
  root: {
    marginLeft: 0,
    marginRight: 0,
    marginTop: theme.spacing(0),
  },
})
